import MetisMenu from "metismenujs";
import { HeaderBase } from "@Base/Site/HeaderBase";

import "./Header.scss";

export class Header extends HeaderBase
{
	private LinkSelector = "a.has-child";
	private MenuBack: HTMLElement;
	private MobileLinkMenu: MetisMenu;
	private MobileSubMenuContent: HTMLElement;
	private MobileSubMenuInstance: MetisMenu;
	private MenuPane: HTMLElement;

	public Menu: HTMLElement;
	public TopMenu: HTMLElement;

	constructor()
	{
		super();
		this.Initialize();
	}

	public Initialize(): void
	{
		super.Initialize();
	}

	public MenuMobileDestroy(): void
	{
		if (typeof this.Menu !== "undefined")
		{
			this.Menu.querySelectorAll(this.LinkSelector).forEach(element =>
			{
				element.removeEventListener("click", this.MobileSubMenuHandler);
			});

			if (this.MenuBack !== null)
			{
				this.MenuBack.removeEventListener("click", this.ShowTopMenuHandler);
			}

			document.querySelector("#offCanvasMenu").removeEventListener("hidden.bs.offcanvas", this.ShowTopMenu);

			this.ShowTopMenu();
			super.MenuMobileDestroy();
		}
	}

	public override MenuMobileOpen = (): void =>
	{
		this.Menu = document.querySelector("#menu");
		this.MenuBack = document.querySelector("#menuBack");
		this.MenuPane = document.querySelector("#menuPane");
		this.MobileMenu = document.querySelector("#mobileMenu");
		this.TopMenu = document.querySelector("#topMenu");

		this.MobileMenu.appendChild(this.TopMenu);

		this.MobileLinkMenu = new MetisMenu("#mobileLinks", {
			triggerElement: this.LinkSelector
		});

		this.Menu.querySelectorAll(this.LinkSelector).forEach(element =>
		{
			element.addEventListener("click", this.MobileSubMenuHandler);
		});

		if (this.MenuBack !== null)
		{
			this.MenuBack.addEventListener("click", this.ShowTopMenuHandler);
		}

		document.querySelector("#offCanvasMenu").addEventListener("hidden.bs.offcanvas", this.ShowTopMenu);
	};

	public MobileSubMenuHandler = (e: Event): void =>
	{
		e.preventDefault();
		this.MobileSubMenuOpen(e.currentTarget);
	};

	public MobileSubMenuOpen = (clicked): void =>
	{
		this.MobileSubMenuContent = document.querySelector("#mobileMenuContent");
		const mobileCategory = document.querySelector("#mobileCategory");

		let menu = "";
		const submenus = clicked.nextElementSibling.querySelectorAll("ul > li:not(.d-none.d-lg-block) > .nav-header");
		const multipleSubmenus = submenus.length > 1;

		submenus.forEach(submenu =>
		{
			if (multipleSubmenus)
			{
				menu += "<li>";
				menu += submenu.outerHTML;
			}

			if (submenu.classList.contains("has-child"))
			{
				const nextEl = submenu.nextElementSibling;

				if (nextEl.tagName.toLowerCase() === "ul")
				{
					if (multipleSubmenus)
					{
						menu += nextEl.outerHTML;
					}
					else
					{
						menu += nextEl.innerHTML;
					}
				}
			}

			if (multipleSubmenus)
			{
				menu += "</li>";
			}
		});

		if (mobileCategory !== null)
		{
			mobileCategory.textContent = clicked.innerText;
		}

		this.MobileSubMenuContent.innerHTML = menu;
		this.MenuPane.style.display = "block";
		this.TopMenu.style.display = "none";

		this.MobileSubMenuInstance = new MetisMenu("#mobileMenuContent", {
			triggerElement: this.LinkSelector
		});

		this.MobileSubMenuContent.querySelectorAll(this.LinkSelector).forEach(link =>
		{
			link.addEventListener("click", (e) =>
			{
				e.preventDefault();
			});
		});
	};

	public ShowTopMenu = (): void =>
	{
		if (getComputedStyle(this.MenuPane).display !== "none")
		{
			this.MobileSubMenuInstance.dispose();
			this.MobileSubMenuContent.classList.remove("metismenu");
			this.MobileSubMenuContent.innerHTML = "";
			this.MenuPane.style.display = "none";
			this.TopMenu.style.display = "block";
		}
	};

	public ShowTopMenuHandler = (e: Event): void =>
	{
		e.preventDefault();
		this.ShowTopMenu();
	};
}